import React from 'react';
import {Link} from 'react-router-dom';
import TimeAgo from 'react-timeago';
import {Colors, Icon} from '@blueprintjs/core';
import {IconName} from '@blueprintjs/icons';

import {FavoriteType, IActivity} from '../../shared/models';
import {ToggleFavorite} from '../../shared/components/Favorite';
import {typePathIcon} from '../../shared/utils/typePathIcon';
import {typePathMap} from '../../shared/utils/typePathMap';

interface RecentActivityProps {
  key?: any;
  activity: IActivity;
}

const getActivityIcon = (activity: IActivity) => {
  const item = activity.item;

  return typePathIcon(item.type, {color: Colors.INDIGO3}) as IconName;
}

const getActivityLink = (activity: IActivity) => {
  const item = activity.item;

  const path = typePathMap(item.type);
  return `/r/${path}edit/${activity.item.uid}`;
};

const RecentActivity = ({activity}: RecentActivityProps) => {
  const link = getActivityLink(activity);
  const icon = getActivityIcon(activity);

  return (
    <div className="home__content__block__item" key={activity.uid}>
      <div className="home__content__block__item__fav">
        <ToggleFavorite
          uid={activity.item.uid}
          id={activity.item.id}
          type={FavoriteType.REPORT}
        />
      </div>
      <Link
        to={link}
        className="home__content__block__item__name__link"
      >
        <Icon
          icon={icon}
          color={Colors.INDIGO3}
        />
        <div className="home__content__block__item__name">
          <div className="home__content__block__item__name__text">
            {activity.item.name}
          </div>
        </div>
        <div className="home__content__block__item__time">
          <TimeAgo date={activity.created_on_utc} live={false} />
        </div>
      </Link>
    </div>
  );
};

export default RecentActivity;
